import { cx } from '@/utils/cx'

/**
 * The Gallop mark: the low-poly horse head from logo concept #4 (Sean, 2026-09-14, "for now as we build").
 * Same artwork as the favicon and the mark on gallopaccounting.ai; the source is a raster, so this is a
 * transparent PNG (128 px, tight crop) rather than an SVG. Sized by the caller (the tree slot is 28 px,
 * the auth frame 36 px). Decorative: the enclosing link or wordmark carries the accessible name.
 */
export function BrandMark({ className }: { className?: string }) {
  return <img src="/brand/gallop-mark-128.png" alt="" aria-hidden width={128} height={128} draggable={false} className={cx('select-none object-contain', className)} />
}
